// extracted by mini-css-extract-plugin
module.exports = {"field":"InformationEdit_field__1ISeP","text":"InformationEdit_text__1f380"};